import React from "react";
import './App.css';
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt, FaLinkedinIn } from "react-icons/fa";
import { FiInstagram } from "react-icons/fi";
import { BsWhatsapp, BsArrowRight } from "react-icons/bs";

function Test() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Newsletter Section */}
        <div className="footer-section">
          <h2 className="footer-heading">
            <span>Get Ready</span> To Create <br />
            Something <span>Great</span>
          </h2>
          <p className="footer-subtext">Subscribe to my newsletter for updates</p>
          <div className="footer-input-wrapper">
            <input 
              type="email" 
              placeholder="Enter your email" 
              className="footer-input" 
            />
            <button className="footer-submit">
              <BsArrowRight />
            </button>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3 className="footer-title">Quick Links</h3>
          <ul className="footer-links">
            <li><a href="#">About Me</a></li>
            <li><a href="#">Services</a></li>
            <li><a href="#">Portfolio</a></li>
            <li><a href="#">Testimonials</a></li>
            <li><a href="#">Contact</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h3 className="footer-title">Contact Info</h3>
          <div className="contact-info">
            <div className="contact-item">
              <div className="contact-icon"><FaEnvelope /></div>
              <a href="mailto:princeguptak22@gmail.com">princeguptak22@gmail.com</a>
            </div>
            <div className="contact-item">
              <div className="contact-icon"><FaMapMarkerAlt /></div>
              <address>
                Ashok Nagar, Safed Pool, Pipe Line,<br />
                Near Eden High School & Junior College,<br />
                Sakinaka, Mumbai - 400072
              </address>
            </div>
            <div className="contact-item">
              <div className="contact-icon"><FaPhoneAlt /></div>
              <a href="tel:+919920818454">+91 9920 818 454</a>
            </div>
          </div>
          <div className="social-links">
            <a href="#" className="social-icon" aria-label="Instagram"><FiInstagram /></a>
            <a href="#" className="social-icon" aria-label="LinkedIn"><FaLinkedinIn /></a>
            <a href="#" className="social-icon" aria-label="WhatsApp"><BsWhatsapp /></a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
    <div className="footer-bottom">
  <p>&copy; {new Date().getFullYear()} Prince Gupta. All Rights Reserved.</p>
  <p className="footer-credit">Design and Developed by Sachin Yadav - JMM Infotech</p>
    <p className="footer-credit">Portfolio : Prince Suryabhan Gupta</p>

</div>

    </footer>
  );
}

export default Test;
